import React from 'react';
import { cn } from '../../utils/cn';

/**
 * Title + optional description for visual hierarchy on dashboard sections.
 */
export function PageHeader({ title, description, className, action, eyebrow }) {
  return (
    <header
      className={cn(
        'flex flex-col gap-1 sm:gap-2 md:flex-row md:items-end md:justify-between md:gap-4 min-w-0',
        className
      )}
    >
      <div className="min-w-0">
        {eyebrow ? (
          <p className="text-[10px] sm:text-xs font-bold uppercase tracking-widest text-slate-400 mb-1">
            {eyebrow}
          </p>
        ) : null}
        <h2 className="text-xl sm:text-2xl md:text-3xl font-black text-slate-900 tracking-tight truncate">
          {title}
        </h2>
        {description ? (
          <p className="text-slate-500 font-medium mt-1 sm:mt-2 text-sm sm:text-base max-w-2xl">
            {description}
          </p>
        ) : null}
      </div>
      {action ? (
        <div className="w-full min-w-0 shrink-0 pt-2 sm:max-w-[min(100%,28rem)] md:max-w-[min(100%,36rem)] md:pt-0 md:ml-auto [&_button]:min-h-[44px] [&_button]:touch-manipulation">
          {action}
        </div>
      ) : null}
    </header>
  );
}
